import React, { useEffect, useState } from "react";

import axios from "axios";

import { IconCreditCard } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  credit_card_brand: string;
}

export const CardBrandImage: React.FC<Props> = ({ credit_card_brand }) => {
  const image_url = `checkout/credit-cards/${credit_card_brand}.svg`;
  const { urlBuilder } = useAppContext();
  const [credit_card_brand_img_url, setImageUrl] = useState<string | null>(
    image_url && urlBuilder.image(image_url)
  );

  useEffect(() => {
    // Check if the card exist on s3 in to fallback if not
    if (credit_card_brand_img_url) {
      axios.head(credit_card_brand_img_url).catch(() => {
        setImageUrl(null);
      });
    }
  });

  return credit_card_brand_img_url ? (
    <img
      width={30}
      height={20}
      src={credit_card_brand_img_url}
      alt={credit_card_brand}
      title={credit_card_brand}
    />
  ) : (
    <IconCreditCard size="md" />
  );
};
